export interface NavActiveTarget {
  to?: string
  exact?: boolean
  external?: boolean
  shouldHighlight?: (currentPath: string) => boolean
}

function withoutTrailingSlash(path: string): string {
  return path.length > 1 && path.endsWith('/') ? path.slice(0, -1) : path
}

export function isNavTargetActive(currentPath: string, target: NavActiveTarget): boolean {
  const { to, exact, external, shouldHighlight } = target

  if (shouldHighlight?.(currentPath)) {
    return true
  }
  if (!to || external || to.startsWith('http') || to.startsWith('#')) {
    return false
  }

  const normalizedTo = withoutTrailingSlash(to)
  const normalizedPath = withoutTrailingSlash(currentPath)

  if (exact) {
    return normalizedPath === normalizedTo
  }
  return normalizedPath === normalizedTo || normalizedPath.startsWith(`${normalizedTo}/`)
}
